import React from "react";

export default function SQLServer_LEN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_LEN</h1>
      <p>This is the SQLServer_LEN component generated from the SQL JSON.</p>
    </div>
  );
}
